import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-20 md:py-32 px-6 bg-navy-light border-t border-navy-lighter" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-108">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-cream mb-2" data-id="element-109">
            EL PROBLEMA NO ES QUE TE DESPIERTES.
          </h2>
          <h3 className="font-serif text-2xl md:text-3xl text-gold mb-8" data-id="element-110">
            Es lo que pasa después.
          </h3>

          <div className="space-y-6 text-lg md:text-xl text-cream-muted leading-relaxed" data-id="element-111">
            <p data-id="element-112">
              Si eres mujer 65+ y estás en menopausia (o postmenopausia),
              probablemente conoces este patrón:
            </p>

            <ul className="space-y-4 my-8 pl-4 border-l-2 border-gold/30" data-id="element-113">
              <li className="pl-4" data-id="element-114">
                <strong className="text-cream" data-id="element-115">
                  Te despiertas entre 3:00 y 4:30am
                </strong>{' '}
                «como reloj».
              </li>
              <li className="pl-4" data-id="element-116">
                <strong className="text-cream" data-id="element-117">
                  Sientes calor, incomodidad,
                </strong>{' '}
                o un «algo» que no te deja tranquila.
              </li>
              <li className="pl-4" data-id="element-118">
                <strong className="text-cream" data-id="element-119">
                  Tu cerebro entra en modo alerta:
                </strong>{' '}
                recuerdos, pendientes, preocupaciones, cálculos.
              </li>
              <li className="pl-4" data-id="element-120">
                <strong className="text-cream" data-id="element-121">
                  Y sin darte cuenta, entrenas tu noche
                </strong>{' '}
                para que 3AM sea el nuevo horario de vigilia.
              </li>
            </ul>

            <div className="bg-navy p-6 rounded-lg border border-navy-lighter shadow-lg mt-8" data-id="element-122">
              <p className="text-xl font-medium text-cream italic text-center" data-id="element-123">
                «No es falta de voluntad. Es un bucle. Y el bucle se rompe con
                un sistema simple, repetible, sin improvisación.»
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}